import { useInfiniteQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "../constants";
import {
  GetMultiplayerTournamentsParams,
  handleGetMultiplayerTournaments,
} from "../../api-clients/tournamentsClient";
import { useMemo } from "react";
import { extractInfoFromInfiniteData, extractListRecords } from "../utils";
import { StakeFiatCurrency } from "@nestcoinco/hyper-api-gateway-api-client";
import useAuth from "../../hooks/useAuth";

interface UseInfiniteMultiplayerTournamentsQueryParams
  extends GetMultiplayerTournamentsParams {
  enabled?: boolean;
}

function useInfiniteMultiplayerTournamentsQuery(
  params?: UseInfiniteMultiplayerTournamentsQueryParams
) {
  const { gameId, limit, statuses, enabled = true } = params ?? {};
  const { userProfile } = useAuth();

  const query = useInfiniteQuery({
    queryKey: [QUERY_KEYS.TOURNAMENT.MULTIPLAYER_TOURNAMENTS],
    queryFn: ({ pageParam }) =>
      handleGetMultiplayerTournaments({
        page: pageParam,
        limit,
        gameId,
        statuses,
        currency: userProfile?.currency as StakeFiatCurrency,
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => lastPage.nextPage,
    getPreviousPageParam: (firstPage) => firstPage.previousPage,
    enabled,
  });

  const tournamentList = useMemo(
    () => extractInfoFromInfiniteData(query.data),
    [query.data]
  );

  const tournaments = useMemo(
    () => extractListRecords(tournamentList),
    [tournamentList]
  );

  return { query, tournaments };
}

export default useInfiniteMultiplayerTournamentsQuery;
